// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VuePhotoswipe from 'vue-photoswipe'
import VeeValidate from 'vee-validate'
import VueTheMask from 'vue-the-mask'
import VueObserveVisibility from 'vue-observe-visibility'

import Breadcrumbs from './components/breadcrumbs.vue'

// Global components
Vue.use(VuePhotoswipe)
Vue.use(VeeValidate)
Vue.use(VueTheMask)
Vue.use(VueObserveVisibility)

Vue.component('Breadcrumbs', Breadcrumbs)

Vue.config.productionTip = false

router.afterEach(() => {
  window.scrollTo(0, 0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js